import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  constructor() {}

  getItem(key: string): string {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      console.error('Error getting item from local storage', e);
    }
  }

  setItem(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
      console.error('Error setting item in local storage', e);
    }
  }

  removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.error('Error removing item in local storage', e);
    }
  }
}
